<script lang="ts">
import {defineComponent} from "vue";
import Parallax from "parallax-js";
import store from "@/store";

export default defineComponent({
    data(): {
        parallaxInstance: Parallax | null,
        tick: number,
    } {
        return {
            parallaxInstance: null,
            tick: 0,
        }
    },

    props: {
        images: {
            type: Array,
            required: true
        }
    },

    mounted(): void
    {
        setInterval(() => {
            this.tick++
        }, 1000)

        const scene = this.$refs.bgs
        if (!(scene instanceof HTMLElement)) {
            return
        }

        this.parallaxInstance = new Parallax(scene)
        if (this.pageWidth <= store.state.mobileVersionThresholdWidth) {
            this.parallaxInstance.disable()
        }
    },

    computed: {
        pageWidth(): number
        {
            return store.state.pageSize.width
        },
    },

    watch: {
        pageWidth: {
            handler(newValue, oldValue): void
            {
                if (newValue <= store.state.mobileVersionThresholdWidth && oldValue > store.state.mobileVersionThresholdWidth) {
                    this.parallaxInstance?.disable()
                } else if (newValue > store.state.mobileVersionThresholdWidth && oldValue <= store.state.mobileVersionThresholdWidth) {
                    this.parallaxInstance?.enable()
                }
            },
        },
    },
})

</script>

<template>
	<div id="bgs" ref="bgs" class="noselect">
		<div
            class="bgImage"
            :class="{
                blur: image.blur,
                dynamicBlur: image.dynamicBlur !== 0 && tick % image.dynamicBlur === 0,
            }"
            v-for="(image, i) in images"
            :key="i"
            :style="{
              backgroundImage: `url('/img/page/landing/bg/${image.image}.webp')`,
              opacity: image.opacity,
            }"
            :data-depth="image.depth"
        />
	</div>
</template>

<style scoped lang="scss">
#bgs {
    position: fixed;
    top: -10%;
    bottom: -10%;
    left: -10%;
    right: -10%;
}

.bgImage {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center center;
    will-change: transform;
    transition: 0.5s filter ease;
    -webkit-transition: 0.5s -webkit-filter ease;
    -moz-transition: 0.5s -moz-filter ease;
    -ms-transition: 0.5s -ms-filter ease;
    -o-transition: 0.5s -o-filter ease;
}

.blur {
    filter: blur(1px);
}

.dynamicBlur {
    filter: blur(5px) !important;
}
</style>
